import React from 'react';
import Head from 'next/head';
import { HOSTNAME } from '@/lib/constants';

interface MetaTagsProps {
    title?: string;
    description?: string;
    pathname?: string;
    url?: string;
    image?: string;
    seo?: {
        meta_title?: string;
        meta_description?: string;
    };
}

const MetaTags = (props: MetaTagsProps) => {
    const { title, description, seo, pathname, url, image } = props;
    const canonicalURL = HOSTNAME + (pathname ? `/${pathname}` : '');

    return (
        <Head>
            <meta charSet="UTF-8" />
            <title>
                {seo?.meta_title ||
                    title ||
                    `ACKO Drive | Buy car at the lowest rates.`}
            </title>
            <meta
                name="title"
                content={
                    seo?.meta_title ||
                    title ||
                    `ACKO Drive | Buy car at the lowest rates.`
                }
            />
            <meta
                name="description"
                content={
                    seo?.meta_description ||
                    description ||
                    `Great discounts on your new car, buy & manage low-cost FASTag, experience easy and quick documentation. ACKO Drive simplifies the entire process and helps you save costs at every step, from buying a new car to selling an old one.`
                }
            />
            <meta name="og:locale" content="en_US" />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0"
            />
            <link rel="canonical" href={canonicalURL} />
            <meta property="og:url" content={url || 'https://ackodrive.com/'} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ACKO Drive" />
            <meta
                property="og:title"
                content={
                    seo?.meta_title ||
                    title ||
                    `ACKO Drive | Buy car at the lowest rates.`
                }
            />
            <meta
                property="og:description"
                content={
                    seo?.meta_description ||
                    description ||
                    `Great discounts on your new car, buy & manage low-cost FASTag, experience easy and quick documentation. ACKO Drive simplifies the entire process and helps you save costs at every step, from buying a new car to selling an old one.`
                }
            />
            <meta
                property="og:image"
                content={
                    image ||
                    'https://ackodrive-assets.ackodrive.com/media/OG_IMAGE.png'
                }
            />
            <meta property="og:image:width" content="800" />
            <meta property="og:image:height" content="400" />
            <meta
                property="fb:app_id"
                content={`${process.env.NEXT_PUBLIC_FB_APP_ID}`}
            />
            <meta property="twitter:card" content="summary_large_image" />
            <meta
                property="twitter:url"
                content={HOSTNAME + (pathname || '')}
            />
            <meta
                property="twitter:title"
                content={
                    seo?.meta_title ||
                    title ||
                    `ACKO Drive | Buy car at the lowest rates.`
                }
            />
            <meta
                property="twitter:description"
                content={
                    seo?.meta_description ||
                    description ||
                    `Great discounts on your new car, buy & manage low-cost FASTag, experience easy and quick documentation. ACKO Drive simplifies the entire process and helps you save costs at every step, from buying a new car to selling an old one.`
                }
            />
            <meta
                property="twitter:image"
                content={
                    image ||
                    'https://ackodrive-assets.ackodrive.com/media/OG_IMAGE.png'
                }
            />
            <meta
                property="twitter:image:alt"
                content={
                    seo?.meta_title ||
                    title ||
                    `ACKO Drive | Buy car at the lowest rates.`
                }
            />
        </Head>
    );
};

export default MetaTags;
